import { SEMButton as SEMButtonComponent } from '@workboard/ui-relationships';
import { ThemeProvider } from '@mui/material';
import { GlobalStyle, theme } from './theme/theme';

function SEMButton(props: any) {
  return (
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <SEMButtonComponent {...props} />
      </ThemeProvider>
  );
}

export default SEMButton;
